/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Colors } from 'utils';
const MaestroCard = ({ color, width, height }) => {
  return (
    <svg
      height={`${height || '100%'}`}
      width={`${width || '100%'}`}
      viewBox="0 0 48.43 48.43"
      css={css`
        fill: ${color || Colors.white};
        max-width: ${width || '100%'};
        max-height: ${height || '100%'};
        height: ${height || '100%'};
        width: ${width || '100%'};
        display: inline-block;
      `}
      xmlns="http://www.w3.org/2000/svg"
      enableBackground="new 0 0 512 512"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      xmlSpace="preserve"
    >
      <g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M47.381,32.029c-0.041-0.076-0.1-0.133-0.177-0.174c-0.074-0.041-0.15-0.062-0.229-0.062c-0.08,0-0.156,0.021-0.23,0.062    c-0.074,0.041-0.135,0.098-0.176,0.174c-0.041,0.073-0.062,0.151-0.062,0.232s0.021,0.159,0.062,0.232    c0.043,0.074,0.101,0.134,0.174,0.175c0.074,0.041,0.152,0.062,0.234,0.062c0.079,0,0.157-0.021,0.231-0.062    c0.073-0.041,0.131-0.101,0.173-0.175c0.041-0.073,0.062-0.152,0.062-0.232C47.443,32.18,47.423,32.102,47.381,32.029z     M47.135,32.435h-0.102l-0.062-0.154H46.91v0.154h-0.082v-0.392h0.164c0.02,0,0.061,0.001,0.102,0.022    c0.021,0.02,0.041,0.059,0.041,0.098c0,0.043-0.02,0.084-0.061,0.102L47.135,32.435z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M47.013,32.123c0-0.008-0.041-0.008-0.062-0.008H46.91v0.101h0.062c0,0,0.021,0,0.041-0.008    c0.021-0.009,0.021-0.028,0.021-0.046C47.034,32.147,47.034,32.131,47.013,32.123z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M33.935,9.716c-3.743,0.001-7.153,1.42-9.723,3.748c-2.572-2.327-5.98-3.745-9.718-3.745c-0.031,0-0.062,0-0.093,0    C6.443,9.771,0,16.245,0,24.214c0,8.002,6.494,14.494,14.494,14.494c3.738,0,7.145-1.418,9.717-3.745    c-0.537-0.485-1.023-1.022-1.482-1.584h2.994c-0.452,0.554-0.945,1.072-1.472,1.552h-0.003c0.001,0.002,0.001,0.002,0.001,0.002    c-0.012,0.011-0.025,0.019-0.037,0.031c2.571,2.331,5.985,3.75,9.729,3.749c8.006-0.002,14.491-6.494,14.489-14.498    c0-0.003,0-0.005,0-0.007C48.428,16.204,41.937,9.716,33.935,9.716z M22.894,14.962h2.754c0.408,0.491,0.785,1.01,1.125,1.552    H21.86C22.174,15.995,22.522,15.464,22.894,14.962z M21.002,18.037h6.605c0.237,0.503,0.445,1.021,0.625,1.553h-8.013    C20.298,19.44,20.578,18.836,21.002,18.037z M13.698,27.69h-1.72l1.024-5.37l-2.355,5.37H9.091l-0.287-5.334L7.78,27.69H6.223    l1.332-6.982h2.683l0.123,4.324l1.905-4.324h2.786L13.698,27.69z M19.782,24.673l-0.369,2.017l-0.061,0.361l-0.041,0.288    l-0.021,0.194l-0.02,0.154h-1.433l0.041-0.587c-0.429,0.468-1.024,0.685-1.802,0.685c-0.922,0-1.557-0.633-1.557-1.549    c0-1.382,1.106-2.19,3.01-2.19c0.184,0,0.43,0.017,0.696,0.044c0.041-0.187,0.062-0.265,0.062-0.369    c0-0.375-0.308-0.515-1.106-0.515c-0.492,0-1.045,0.059-1.413,0.157l-0.246,0.062l-0.143,0.037l0.225-1.279    c0.86-0.218,1.413-0.299,2.048-0.299c1.474,0,2.253,0.577,2.253,1.665C19.905,23.831,19.885,24.042,19.782,24.673z M23.204,21.871    c1.412,0,2.314,0.803,2.314,2.062c0,0.421-0.062,0.828-0.207,1.404h-3.398c-0.021,0.087-0.021,0.126-0.021,0.18    c0,0.657,0.512,0.992,1.495,0.992c0.615,0,1.168-0.11,1.782-0.36l-0.286,1.422c-0.574,0.154-1.147,0.229-1.741,0.229    c-1.925,0-2.929-0.873-2.929-2.546C20.213,23.307,21.483,21.873,23.204,21.871z M26.791,31.888h-5.143    c-0.312-0.5-0.605-1.013-0.856-1.552h6.843C27.384,30.873,27.103,31.389,26.791,31.888z M29.942,23.315    c-0.451-0.052-0.901-0.083-1.25-0.083c-0.554,0-0.84,0.156-0.84,0.461c0,0.266,0.082,0.33,0.799,0.618    c0.879,0.345,1.229,0.802,1.229,1.581c0,1.296-0.84,1.895-2.684,1.895c-0.224,0-0.531-0.017-0.941-0.047    c-0.205-0.015-0.368-0.031-0.472-0.052l-0.307-0.056l-0.082-0.016l0.246-1.31c0.553,0.156,1.026,0.224,1.557,0.224    c0.676,0,0.983-0.158,0.983-0.512c0-0.26-0.103-0.344-0.799-0.627c-0.921-0.371-1.331-0.867-1.331-1.583    c0-1.049,0.676-1.922,2.602-1.922c0.41,0,1.086,0.05,1.535,0.112L29.942,23.315z M32.627,26.419c0.183,0,0.326-0.018,0.449-0.055    l-0.225,1.26c-0.471,0.129-0.839,0.186-1.229,0.186c-0.881,0-1.352-0.443-1.352-1.248c0-0.16,0.02-0.33,0.041-0.51l0.103-0.559    l0.081-0.449l0.799-4.336h1.699l-0.245,1.304h0.88l-0.246,1.382h-0.881l-0.45,2.369c-0.021,0.103-0.021,0.181-0.021,0.234    C32.03,26.292,32.215,26.417,32.627,26.419z M36.816,23.61c-0.819,0-1.084,0.61-1.699,4.083h-1.721l1.045-5.68h1.557l-0.164,0.862    c0.533-0.671,0.941-0.923,1.495-0.923c0.062,0,0.124,0.006,0.185,0.014c0,0.003,0.063,0.014,0.146,0.034    c0.02,0.006,0.04,0.006,0.184,0.062l-0.612,1.605l-0.205-0.042C36.945,23.615,36.884,23.61,36.816,23.61z M39.855,27.842    c-1.95,0-2.726-1.178-2.726-2.619c0-2.011,1.331-3.376,3.379-3.376c1.784,0,2.726,1.122,2.726,2.562c0,0.353,0,0.377-0.041,0.707    C42.926,27.005,41.615,27.844,39.855,27.842z M43.377,27.69c-0.246,0-0.451-0.199-0.451-0.445c0-0.242,0.205-0.441,0.451-0.441    c0.246,0,0.451,0.199,0.451,0.441C43.828,27.492,43.623,27.69,43.377,27.69z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M43.377,26.909c-0.184,0-0.348,0.151-0.348,0.336c0,0.19,0.164,0.34,0.348,0.34c0.185,0,0.328-0.152,0.328-0.34    C43.705,27.061,43.562,26.909,43.377,26.909z M43.54,27.443h-0.103l-0.062-0.153h-0.062v0.153h-0.082V27.05h0.164    c0.022,0,0.063,0.002,0.104,0.023c0.02,0.019,0.041,0.058,0.041,0.098c0,0.042-0.021,0.084-0.062,0.102L43.54,27.443z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M43.417,27.13c0.001-0.009-0.04-0.009-0.06-0.009h-0.043v0.101h0.062c0,0,0.021,0,0.041-0.008    c0.021-0.009,0.021-0.028,0.021-0.045C43.438,27.154,43.438,27.138,43.417,27.13z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M23.183,23.172c-0.553,0-0.942,0.361-1.106,1.019l1.905,0.004c0-0.124,0-0.22,0-0.294    C23.982,23.44,23.695,23.172,23.183,23.172z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M17.631,25.139c-0.961-0.001-1.453,0.29-1.453,0.864c0,0.353,0.226,0.579,0.614,0.579c0.697,0,1.188-0.582,1.229-1.422    C17.836,25.141,17.754,25.139,17.631,25.139z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M40.468,23.237c-0.881,0-1.413,1.035-1.413,1.947c0,0.772,0.368,1.29,0.983,1.278c0.37,0,1.167-0.509,1.311-1.392    c0.04-0.207,0.061-0.434,0.061-0.681C41.41,23.797,41.165,23.235,40.468,23.237z"
              fill={color || Colors.white}
              data-original="#000000"
            />
          </g>
        </g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
        <g xmlns="http://www.w3.org/2000/svg"></g>
      </g>
    </svg>
  );
};

export default MaestroCard;

MaestroCard.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};
